<template>
  <div id="xmsq" class="publicMain">
    <el-row class="leftClass">
      <el-col :span="9">
        <label style="width: 100px;">{{ $t("xmsq.queryFormsqxt") }}：</label>
        <el-button
          size="small"
          :class="{ btnColor: btncolor == 'cx' }"
          type="primary"
          plain
          @click="getXmsqinfo('cx')"
          >{{ $t("xmsq.wscxxt") }}</el-button
        >
        <el-button
          size="small"
          :class="{ btnColor: btncolor == 'bx' }"
          type="primary"
          plain
          @click="getXmsqinfo('bx')"
          >{{ $t("xmsq.wsbxxt") }}</el-button
        >
        <el-button
          size="small"
          :class="{ btnColor: btncolor == 'sb' }"
          type="primary"
          plain
          @click="getXmsqinfo('sb')"
          >{{ $t("xmsq.srsbxt") }}</el-button
        >
        <p class="color-r fs-14 ml-80 mt-5">* 请先选择要授权的系统！</p>
      </el-col>
      <!-- 被授权人 -->
      <el-col :span="15">
        <label style="width: 100px;">{{ $t("xmsq.queryFormbsqr") }}：</label>
        <el-input
          v-model="yhbhoryhmc"
          size="small"
          @blur="getUserinfo"
          style="width: 15%;"
        >
          <template #suffix>
            <i
              class="el-icon-search el-input__icon color-b cursor-p"
              @click="handleIconClick"
            ></i>
          </template>
        </el-input>
        <span ref="yhbhoryhmc2" style="width: 200px;"></span>
      </el-col>
    </el-row>
    <el-row class="rightClass">
      <el-col :span="12" style="text-align: left;">
        <span class="demonstration">{{ $t("xmsq.queryFormqzrq") }}：</span>
        <el-date-picker
          v-model="value2"
          type="daterange"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          align="right"
          size="small"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="12">
        <el-button size="small" type="primary" @click="sqOperateWc">{{
          $t("xmsq.sqBtn")
        }}</el-button>
        <el-button size="small" @click="resetSearch('reset')">{{
          $t("xmsq.resetBtn")
        }}</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-table
        v-loading="tabLoading"
        :element-loading-text="$t('elTable.loadingText')"
        element-loading-spinner="el-icon-loading"
        :data="tableData"
        :key="tableKey"
        border
        stripe
        ref="multipleTable"
        @selection-change="handleSelectionChange"
        style="width: 100%; font-size: 12px;"
        @cell-click="cellClick"
        @select="checkboxEvent"
        :header-cell-style="$store.state.headerCellStyle"
        :cell-style="$store.state.cellStyle"
      >
        <el-table-column
          type="selection"
          width="40"
          key="1"
          align="center"
          header-align="center"
        ></el-table-column>
        <el-table-column
          prop="bmmc"
          :label="$t('xmsq.bmmc')"
          width="220px"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.bmbh }} / {{ scope.row.bmmc }}
          </template>
        </el-table-column>
        <el-table-column
          prop="xmsx"
          :label="$t('xmsq.xmsx')"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            {{
              scope.row.xmsx == "1"
                ? $t("xmsq.personal")
                : scope.row.xmsx == "2"
                ? $t("xmsq.public")
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="xmmc"
          :label="$t('xmsq.xmmc')"
          width="450px"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            ({{ scope.row.xmbh }}) {{ scope.row.xmmc }} -- {{ scope.row.fzr }}
          </template>
        </el-table-column>
        <el-table-column
          prop="isecsq"
          :label="$t('xmsq.ecsq')"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.isecsq"
              v-show="scope.row.isecsqinp"
              @change="losechange(scope.$index, scope.row)"
              @blur="loseFcous(scope.$index, scope.row)"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span v-show="!scope.row.isecsqinp">{{
              scope.row.isecsq == "0" ? $t("xmsq.notallow") : $t("xmsq.allow")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="wcqsrq"
          :label="$t('xmsq.qsrq')"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.wcqsrq"
              value-format="yyyy-MM-dd"
              v-if="scope.row.qsrqinp"
              type="date"
              @change="losechange(scope.$index, scope.row)"
              @blur="loseFcous(scope.$index, scope.row)"
            >
            </el-date-picker>
            <span v-else>{{ scope.row.wcqsrq }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="wcjzrq"
          :label="$t('xmsq.jzrq')"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-date-picker
              v-model="scope.row.wcjzrq"
              value-format="yyyy-MM-dd"
              v-if="scope.row.jzrqinp"
              type="date"
              @change="losechange(scope.$index, scope.row)"
              @blur="loseFcous(scope.$index, scope.row)"
            >
            </el-date-picker>
            <span v-else>{{ scope.row.wcjzrq }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="yeck"
          :label="$t('xmsq.yeck')"
          v-if="yeckshow"
          key="yeckshow"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.yeck"
              v-show="scope.row.yeckinp"
              @change="losechange(scope.$index, scope.row)"
              @blur="loseFcous(scope.$index, scope.row)"
            >
              <el-option
                v-for="item in yeckoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span v-show="!scope.row.yeckinp">{{
              scope.row.yeck == "0" ? $t("xmsq.fou") : $t("xmsq.shi")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="kzsqje"
          :label="$t('xmsq.kzsqje')"
          v-if="kzsqjeeshow"
          key="kzsqjeeshow"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.kzsqje"
              v-show="scope.row.kzsqjeinp"
              @change="losechange(scope.$index, scope.row)"
              @blur="loseFcous(scope.$index, scope.row)"
            >
              <el-option
                v-for="item in kzsqjeoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <span v-show="!scope.row.kzsqjeinp">{{
              scope.row.kzsqje == "0" ? $t("xmsq.fou") : $t("xmsq.shi")
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="bcsqje"
          :label="$t('xmsq.bcsqje')"
          v-if="bcsqjeshow"
          key="bcsqjeshow"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.bcsqje"
              v-if="scope.row.bcsqjeinp"
              onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"
              @blur="loseFcous(scope.$index, scope.row)"
            ></el-input>
            <span v-else>{{ jeFormat(scope.row.bcsqje) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="ysqje"
          :label="$t('xmsq.ysqje')"
          v-if="ysqjeshow"
          key="ysqjeshow"
          align="center"
          header-align="center"
        ></el-table-column>
        <el-table-column
          prop="yhfje"
          :label="$t('xmsq.yhfje')"
          v-if="yhfjeshow"
          key="yhfjeshow"
          align="center"
          header-align="center"
        ></el-table-column>
      </el-table>
    </el-row>

    <!--被授权人信息模态框-->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
    >
      <div style="height:500px;" class="scrollbar">
        <el-scrollbar style="height:100%">
          <label slot="title">
            <span style="margin-right: 5px;">{{ this.dialogTitle }}</span>
          </label>
          <el-table
            v-loading="tabLoading"
        :element-loading-text="$t('elTable.loadingText')"
            :data="rylbData"
            border
            style="width: 100%; font-size: 12px;"
            highlight-current-row
            @current-change="handleCurrentChange"
          >
            <el-table-column
              :label="$t('xmsq.gh')"
              prop="RYDM"
            ></el-table-column>
            <el-table-column :label="$t('xmsq.xm')" prop="XM"></el-table-column>
            <el-table-column
              :label="$t('xmsq.bm')"
              prop="BMMC"
            ></el-table-column>
          </el-table>
        </el-scrollbar>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">{{
          $t("common.cancelBtn")
        }}</el-button>
        <el-button type="primary" size="small" @click="querenBtn"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
const initials = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j"];
export default {
  name: "sqgl",
  computed: {},
  data() {
    return {
      btncolor: "",
      flg: "0",
      currentRow: null,
      rylbData: [],
      dialogTitle: "人员列表",
      dialogFormVisible: false,
      tableKey: 0,
      queryForm: {
        system: "",
        bsqrzjh: "",
        xm: "",
      },
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t("xmsq.onemonth"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("xmsq.threemonths"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("xmsq.sixmonths"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: this.$t("xmsq.cqyx"),
            onClick(picker) {
              const end = new Date("2050-12-31");
              const start = new Date();
              // end.setTime(start.getTime() + 3600 * 1000 * 24 * 365 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      options: [
        {
          value: "1",
          label: "允许",
        },
        {
          value: "0",
          label: "不允许",
        },
      ],
      yeckoptions: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      kzsqjeoptions: [
        {
          value: "1",
          label: "是",
        },
        {
          value: "0",
          label: "否",
        },
      ],
      yhbhoryhmc: "",
      multipleSelection: [],
      value2: [],
      radio: 0,
      yeckshow: false,
      kzsqjeeshow: false,
      bcsqjeshow: false,
      ysqjeshow: false,
      yhfjeshow: false,
      tableData: [],
      tabLoading: false, // 表格请求数据loading层
      disabledFlg: false, // 输入框是否可编辑
      showFlg: false, // 元素是否显示
      // screenHeight: "0",
      dialogbsqr: false,
      ryxxData: [],
      uniqueNum: "Y120101-1-1",
      value: [],
      ryoptions: Array.from({ length: 1000 }).map((_, idx) => ({
        value: `选项${idx + 1}`,
        label: `${initials[idx % 10]}${idx}`,
      })),
    };
  },
  methods: {
    handleCurrentChange(val) {
      this.currentRow = val;
    },
    losechange(index, row) {
      row.isecsqinp = false;
      row.qsrqinp = false;
      row.jzrqinp = false;
      row.yeckinp = false;
      row.kzsqjeinp = false;
      row.bcsqjeinp = false;
    },
    loseFcous(index, row) {
      row.isecsqinp = false;
      row.qsrqinp = false;
      row.jzrqinp = false;
      row.yeckinp = false;
      row.kzsqjeinp = false;
      row.bcsqjeinp = false;
    },
    cellClick(row, column, cell, event) {
      if (column.property === "isecsq") {
        if (row.fzrbh == this.yhxx.ygbh) {
          row.isecsqinp = true;
          this.$nextTick(() => {
            let inp =
              cell.firstElementChild.firstElementChild.firstElementChild;
            inp.click();
          });
        }
      } else if (column.property === "wcqsrq") {
        row.qsrqinp = true;
        this.$nextTick(() => {
          let inp = cell.firstElementChild.firstElementChild.firstElementChild;
          inp.focus();
        });
      } else if (column.property === "wcjzrq") {
        row.jzrqinp = true;
        this.$nextTick(() => {
          let inp = cell.firstElementChild.firstElementChild.firstElementChild;
          inp.focus();
        });
      } else if (column.property === "yeck") {
        row.yeckinp = true;
        this.$nextTick(() => {
          let inp = cell.firstElementChild.firstElementChild.firstElementChild;
          inp.click();
        });
      } else if (column.property === "kzsqje") {
        row.kzsqjeinp = true;
        this.$nextTick(() => {
          let inp = cell.firstElementChild.firstElementChild.firstElementChild;
          inp.click();
        });
      } else if (column.property === "bcsqje") {
        row.bcsqjeinp = true;
        this.$nextTick(() => {
          let inp = cell.firstElementChild.firstElementChild.firstElementChild;
          inp.focus();
        });
      }
    },

    checkboxEvent(scope) {
      if (this.value2.length > 0) {
        scope.forEach((item) => {
          item.wcqsrq = this.value2[0];
          item.wcjzrq = this.value2[1];
        });
      }
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    // 网查授权项目
    getXmsqinfo(system) {
      let _this = this;

      if (system == "cx") {
        _this.btncolor = system;
        _this.yeckshow = false;
        _this.kzsqjeeshow = false;
        _this.bcsqjeshow = false;
        _this.ysqjeshow = false;
        _this.yhfjeshow = false;
      } else if (system == "bx") {
        _this.btncolor = system;
        _this.yeckshow = true;
        _this.kzsqjeeshow = true;
        _this.bcsqjeshow = true;
        _this.ysqjeshow = true;
        _this.yhfjeshow = false;
      } else if (system == "sb") {
        _this.btncolor = system;
        _this.yeckshow = false;
        _this.kzsqjeeshow = true;
        _this.bcsqjeshow = true;
        _this.ysqjeshow = true;
        _this.yhfjeshow = true;
      }
      _this.queryForm.system = system;
      _this.tableData = [];
      _this.tabLoading = true; // 关闭请求时的loading层
      _this.$ajax
        .post("/api/getXmsqinfo", _this.queryForm)
        .then((res) => {
          _this.tabLoading = false; // 关闭请求时的loading层
          if (res.data.code == "200") {
            res.data.data.forEach((item) => {
              item.yeck = "0";
              item.kzsqje = "1";
              item.wcqsrq = "";
              item.wcjzrq = "";
            });
            _this.tableData = res.data.data;
          }
        })
        .catch((error) => {
          _this.tabLoading = false; // 关闭请求时的loading层
        });
    },

    // 被授权人
    getUserinfo() {
      let _this = this;
      if (_this.yhbhoryhmc == "") {
        this.$refs.yhbhoryhmc2.innerHTML = "";
      } else {
        _this.$ajax
          .post(
            "/api/getUserinfo",
            _this.$qs.stringify({ yhbhoryhmc: _this.yhbhoryhmc })
          )
          .then((res) => {
            if (res.data.code == "200") {
              if (res.data.data.ryxx.length == 0) {
                this.$refs.yhbhoryhmc2.innerHTML = "";
                _this.$message.error(_this.$t("xmsq.zbdryxx"));
              }
              // else {
              //   this.rylbData = res.data.data.ryxx;
              //   if (res.data.data.flg == "1") {
              //     this.$refs.yhbhoryhmc2.innerHTML = res.data.data.ryxx[0].XM;
              //     this.queryForm.bsqrzjh = this.yhbhoryhmc;
              //     this.queryForm.xm = res.data.data.ryxx[0].XM;
              //   } else if (res.data.data.flg == "2") {
              //     this.$refs.yhbhoryhmc2.innerHTML = res.data.data.ryxx[0].RYDM;
              //     this.queryForm.bsqrzjh = res.data.data.ryxx[0].RYDM;
              //     this.queryForm.xm = _this.yhbhoryhmc;
              //   }
              //   _this.getYsqxm();
              // }
            }
          });
      }
    },

    // 金额格式化
    jeFormat(je) {
      var newje;
      var strje = String(je);
      var index = strje.indexOf(".");

      // 不带小数
      if (index == -1) {
        newje = strje.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");

        // 带小数
      } else {
        var zs = strje.substring(0, index);
        var xs = strje.substring(index + 1);
        zs = zs.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
        newje = zs + "." + xs;
      }
      return newje;
    },

    // 获取已授权信息
    getYsqxm(scope) {
      let _this = this;
      _this.$ajax
        .post("/api/getYsqxm", _this.queryForm)
        .then((res) => {
          if (res.data.code == "200") {
            let data = res.data.data;
            if (_this.queryForm.system == "cx") {
              for (let i = 0; i < data.length; i++) {
                for (let j = 0; j < _this.tableData.length; j++) {
                  if (
                    data[i].xmbh == _this.tableData[j].xmbh &&
                    data[i].bmbh == _this.tableData[j].bmbh
                  ) {
                    _this.tableData[j].wcqsrq =
                      data[i].cxqsrq.slice(0, 4) +
                      "-" +
                      data[i].cxqsrq.slice(4, 6) +
                      "-" +
                      data[i].cxqsrq.slice(6, 8);
                    _this.tableData[j].wcjzrq =
                      data[i].cxjzrq.slice(0, 4) +
                      "-" +
                      data[i].cxjzrq.slice(4, 6) +
                      "-" +
                      data[i].cxjzrq.slice(6, 8);
                  }
                }
              }
            } else if (_this.queryForm.system == "bx") {
              for (let i = 0; i < data.length; i++) {
                for (let j = 0; j < _this.tableData.length; j++) {
                  if (
                    data[i].xmbh == _this.tableData[j].xmbh &&
                    data[i].bmbh == _this.tableData[j].bmbh
                  ) {
                    _this.tableData[j].wcqsrq =
                      data[i].bxqsrq.slice(0, 4) +
                      "-" +
                      data[i].bxqsrq.slice(4, 6) +
                      "-" +
                      data[i].bxqsrq.slice(6, 8);
                    _this.tableData[j].wcjzrq =
                      data[i].bxjzrq.slice(0, 4) +
                      "-" +
                      data[i].bxjzrq.slice(4, 6) +
                      "-" +
                      data[i].bxjzrq.slice(6, 8);
                    _this.tableData[j].yeck = data[i].yeck;
                    _this.tableData[j].ysqje = _this.jeFormat(data[i].bxsqje);
                  }
                }
              }
            } else if (_this.queryForm.system == "sb") {
              for (let i = 0; i < data.length; i++) {
                for (let j = 0; j < _this.tableData.length; j++) {
                  if (
                    data[i].xmbh == _this.tableData[j].xmbh &&
                    data[i].bmbh == _this.tableData[j].bmbh
                  ) {
                    _this.tableData[j].wcqsrq =
                      data[i].sbqsrq.slice(0, 4) +
                      "-" +
                      data[i].sbqsrq.slice(4, 6) +
                      "-" +
                      data[i].sbqsrq.slice(6, 8);
                    _this.tableData[j].wcjzrq =
                      data[i].sbjzrq.slice(0, 4) +
                      "-" +
                      data[i].sbjzrq.slice(4, 6) +
                      "-" +
                      data[i].sbjzrq.slice(6, 8);
                    _this.tableData[j].ysqje = _this.jeFormat(data[i].sbsqje);
                  }
                }
              }
            }
            this.tableKey += 1;
          }
        });
    },

    // 确认授权操作
    sqOperateWc() {
      let _this = this;
      if (_this.multipleSelection.length == 0) {
        _this.$message.error(_this.$t("xmsq.qxzsqxm"));
        return false;
      } else if (_this.yhbhoryhmc == "") {
        _this.$message.error(_this.$t("xmsq.qsrbsqr"));
        return false;
      }
      for (let i = 0; i < _this.multipleSelection.length; i++) {
        // if (_this.multipleSelection[i].isecsq == "0"){
        //     _this.$message.error('"('+_this.multipleSelection[i].xmbh+')'+_this.multipleSelection[i].xmmc+'"'+_this.$t('xmsq.notallowecsq'));
        //     return false;
        // }else
        if (
          _this.multipleSelection[i].wcqsrq == "" ||
          _this.multipleSelection[i].wcjzrq == ""
        ) {
          _this.$message.error(
            '"(' +
              _this.multipleSelection[i].xmbh +
              ")" +
              _this.multipleSelection[i].xmmc +
              '"' +
              _this.$t("xmsq.rqtxbwz")
          );
          return false;
        } else if (
          _this.multipleSelection[i].wcqsrq > _this.multipleSelection[i].wcjzrq
        ) {
          _this.$message.error(
            '"(' +
              _this.multipleSelection[i].xmbh +
              ")" +
              _this.multipleSelection[i].xmmc +
              '"' +
              _this.$t("xmsq.jzrqdyqsrq")
          );
          return false;
        } else if (
          _this.multipleSelection[i].kzsqje == "1" &&
          _this.multipleSelection[i].bcsqje <= 0
        ) {
          _this.$message.error(
            '"(' +
              _this.multipleSelection[i].xmbh +
              ")" +
              _this.multipleSelection[i].xmmc +
              '"' +
              _this.$t("xmsq.bcsqjexdy0")
          );
          return false;
        }
      }

      _this
        .$confirm(
          _this.$t("xmsq.Confirmauthorization"),
          _this.$t("xmsq.Confirmationinformation"),
          {
            distinguishCancelAndClose: true,
            confirmButtonText: _this.$t("xmsq.confirmBtn"),
            cancelButtonText: _this.$t("xmsq.cancelBtn"),
          }
        )
        .then((res1) => {
          if (_this.queryForm.system == "cx") {
            _this.$ajax
              .post(
                "/api/sqOperateWc",
                _this.$qs.stringify({
                  datalist: JSON.stringify(_this.multipleSelection),
                  bsqrzjh: _this.queryForm.bsqrzjh,
                })
              )
              .then((res) => {
                if (res.data.code == "200") {
                  _this.resetSearch();
                  _this.getXmsqinfo(_this.queryForm.system);
                  _this.$message.success(_this.$t("xmsq.CzSuccess"));
                }
              });
          } else if (_this.queryForm.system == "bx") {
            _this.$ajax
              .post(
                "/api/sqOperateBx",
                _this.$qs.stringify({
                  datalist: JSON.stringify(_this.multipleSelection),
                  bsqrzjh: _this.queryForm.bsqrzjh,
                  xm: _this.queryForm.xm,
                })
              )
              .then((res) => {
                if (res.data.code == "200") {
                  _this.resetSearch();
                  _this.getXmsqinfo(_this.queryForm.system);
                  _this.$message.success(_this.$t("xmsq.CzSuccess"));
                }
              });
          } else if (_this.queryForm.system == "sb") {
            _this.$ajax
              .post(
                "/api/sqOperateSb",
                _this.$qs.stringify({
                  datalist: JSON.stringify(_this.multipleSelection),
                  bsqrzjh: _this.queryForm.bsqrzjh,
                })
              )
              .then((res) => {
                if (res.data.code == "200") {
                  _this.resetSearch();
                  _this.getXmsqinfo(_this.queryForm.system);
                  _this.$message.success(_this.$t("xmsq.CzSuccess"));
                }
              });
          }
        })
        .catch((action) => {});
    },

    querenBtn() {
      if (this.flg == "1") {
        this.yhbhoryhmc = this.currentRow.RYDM;
        this.$refs.yhbhoryhmc2.innerHTML = this.currentRow.XM;
      } else if (this.flg == "2") {
        this.yhbhoryhmc = this.currentRow.XM;
        this.$refs.yhbhoryhmc2.innerHTML = this.currentRow.RYDM;
      }
      this.dialogFormVisible = false;
    },
    // 查询项目人员
    handleIconClick() {
      if (this.yhbhoryhmc != null && this.yhbhoryhmc != "") {
        let _this = this;
        if (_this.yhbhoryhmc == "") {
          this.$refs.yhbhoryhmc2.innerHTML = "";
        } else {
          _this.$ajax
            .post(
              "/api/getUserinfo",
              _this.$qs.stringify({ yhbhoryhmc: _this.yhbhoryhmc })
            )
            .then((res) => {
              if (res.data.code == "200") {
                if (res.data.data.ryxx.length == 0) {
                  _this.$message.error(_this.$t("xmsq.zbdryxx"));
                } else {
                  this.rylbData = res.data.data.ryxx;
                  this.flg = res.data.data.flg;
                  if (res.data.data.ryxx.length == 1) {
                    if (res.data.data.flg == "1") {
                      this.$refs.yhbhoryhmc2.innerHTML =
                        res.data.data.ryxx[0].XM;
                      this.queryForm.bsqrzjh = this.yhbhoryhmc;
                      this.queryForm.xm = res.data.data.ryxx[0].XM;
                    } else if (res.data.data.flg == "2") {
                      this.$refs.yhbhoryhmc2.innerHTML =
                        res.data.data.ryxx[0].RYDM;
                      this.queryForm.bsqrzjh = res.data.data.ryxx[0].RYDM;
                      this.queryForm.xm = _this.yhbhoryhmc;
                    }
                    _this.getYsqxm();
                  } else {
                    this.dialogFormVisible = true;
                  }
                }
              }
            });
        }
      }
    },
    /** 重置操作 */
    resetSearch(typeFlg) {
      this.yhbhoryhmc = "";
      this.$refs.yhbhoryhmc2.innerHTML = "";
      this.value2 = [];
    },
  },
  mounted() {
    // 监听浏览器的宽和高
    // this.screenHeight = document.body.clientHeight;
    // window.addEventListener(
    //   "resize",
    //   () => (this.screenHeight = window.innerHeight),
    //   false
    // );
  },
};
</script>
<style lang="scss" scoped>
.btnColor {
  background-color: rgb(64, 158, 255);
  color: white;
}
.rightClass {
  margin: 10px 0;
}

/* switch按钮样式 */
::v-deep .isWebClass {
  .el-switch__label--left {
    position: relative;
    left: 37px;
    margin-right: 0;
    color: #fff;
    z-index: -1111;
  }

  .el-switch__core {
    width: 50px !important;
  }

  .el-switch__label--right {
    position: relative;
    right: 37px;
    margin-left: 0;
    color: #fff;
    z-index: -1111;
  }

  .el-switch__label--right.is-active {
    z-index: 1111;
    color: #fff !important;
  }

  .el-switch__label--left.is-active {
    z-index: 1111;
    color: #9c9c9c !important;
  }
}

::v-deep .isOkClass {
  .el-switch__label--left {
    position: relative;
    left: 52px;
    margin-right: 0;
    color: #fff;
    z-index: -1111;
  }

  .el-switch__core {
    width: 70px !important;
  }

  .el-switch__label--right {
    position: relative;
    right: 52px;
    margin-left: 0;
    color: #fff;
    z-index: -1111;
  }

  .el-switch__label--right.is-active {
    z-index: 1111;
    color: #fff !important;
  }

  .el-switch__label--left.is-active {
    z-index: 1111;
    color: #9c9c9c !important;
  }
}
</style>
